import React, { useState } from 'react';
import { Box, VStack, Heading, Span, Button, HStack, Text } from '@bpba/ui-components';
import { useNavigate } from 'react-router-dom';
import { ADHESION_COMERCIOS_FORM } from '../Constantes';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import ComboSucursales from "./ComboSucursales";
import { Queries } from "../rest/Queries";
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { Localidad } from '../rest/models/Localidad';
import { AdhesionComerciosPreSolicitudApiRQ } from '../rest/models/AdhesionComerciosPreSolicitudApiRQ';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { postAdhesionComerciosPreSolicitud } from '../rest/mutations/postAdhesionComerciosPreSolicitud';
import { useTurnstile } from 'react-turnstile';
import RubrosOption from './fragments/Rubros';


type Props = {
    email: string
    cuit: number
    esCliente: boolean
    tipoPersona: number
    sucursalCliente?: number
    origenSolicitud: string
    razonSocial: string
};

export const AdhesionComerciosPersonaJuridica: React.FC<Props> = ({ email, cuit, esCliente, sucursalCliente, origenSolicitud, tipoPersona, razonSocial }: Props) => {


    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>();
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [nroSolicitud, setNroSolicitud] = useState(0);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const REQUIRED_FIELD = "Campo requerido.";
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [datosCopiados, setdatosCopiados] = useState<boolean>(false);
    const [adjuntar, setAdjuntar] = useState(false);
    const toknTurnstile = useTurnstile();

    const [postAdhesionComerciosPreSolicitudApi, { loading: loadingMutation }] = useMutation<Mutations>(postAdhesionComerciosPreSolicitud);

    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });


    const { register, handleSubmit, control, getValues, setValue, formState: { errors }, reset } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            genero: ""
        }
    });
    setValue("cuit", cuit);
    setValue("email", email);
    if (esCliente) {
        setValue("sucursal", sucursalCliente);
        setValue("razonSocial", razonSocial);
    }


    const onSubmit: SubmitHandler<any> = async (data: any) => {

        toknTurnstile.execute(document.getElementById('turnStileTkncontainer'), {
            sitekey: process.env.REACT_APP_TKN_SITEKEY!,
            callback: async (token: any) => {

                let datos: AdhesionComerciosPreSolicitudApiRQ = {
                    "googleToken": token,
                    "email": email,
                    "cuit": cuit,
                    "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
                    "domicilioComercio": data.provinciaComercio.split('-')[1] + "," + data.localidadComercio + "," + data.calleComercio + " " + data.numeroCalleComercio + "," + data.pisoComercio + "," + data.departamentoComercio + "," + data.codigoPostalComercio,
                    "sucursal": Number(data.sucursal),
                    "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud,
                    "rubro": data.rubro,
                    "actividad": 1,
                    "razonSocial": esCliente ? razonSocial : data.razonSocial,
                    "datosTributarios": esCliente ? -1 : Number(data.datosTributarios)
                };

                if (!esCliente) {
                    datos.datosApoderado = data.apoderadoNombre + " " + data.apoderadoApellido + ", " + data.apoderadoDni
                    datos.domicilioLegal = data.provincia.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso + "," + data.departamento + "," + data.codigoPostal
                }


                await postAdhesionComerciosPreSolicitudApi({ variables: { input: datos } }).then((response: any) => {


                    if (response.data?.AdhesionComerciosPreSolicitudApiRQ.resultado.toUpperCase() === "OK") {
                        setServicioOk(true);
                        setNroSolicitud(response.data?.AdhesionComerciosPreSolicitudApiRQ.nroSolicitud)
                        setAdjuntar(true)
                        setMensajeRtaServicio(<><Text fontSize={"20px"} margin={0} fontWeight={600}>A través de la opción “Adjuntar archivos”, podés enviar copia digitalizada de la documentación solicitada.</Text><Text fontSize={"16px"} margin={0}>Podrás cargar los siguientes formatos : image/gif, image/jpg, image/jpeg, image/png, txt, csv, bmp, tiff,pdf,docx  (tamaño máximo 1MB).</Text></>);

                    } else if (response.data.AdhesionComerciosPreSolicitudApiRQ.mensaje.includes("editarse")) {
                        setServicioOk(true);
                        setMensajeRtaServicio("Ya existe un registro con este cuit");
                    } else {
                        setServicioOk(true);
                        setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                    }


                }).catch(() => {
                    setServicioOk(true);
                    setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
                });

            } 
        });
    }

    const copiarDatos = (e: any) => {

        if (e.target.checked) {
            setdatosCopiados(true)
            setValue("provinciaComercio", getValues("provincia").split('-')[1])
            setValue("localidadComercio", getValues("localidad"))
            setValue("calleComercio", getValues("calle"))
            setValue("numeroCalleComercio", getValues("numeroCalle"))
            setValue("codigoPostalComercio", getValues("codigoPostal"))
        } else {
            setdatosCopiados(false)
            setValue("provinciaComercio", "")
            setValue("localidadComercio", "")
            setValue("calleComercio", "")
            setValue("numeroCalleComercio", "")
            setValue("codigoPostalComercio", "")
        }
    }


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);
    }

    const handleRedirect = () => {
        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud: nroSolicitud,
                banner: ADHESION_COMERCIOS_FORM,
                titulo: "Adhesion comercios",
                masDeUnArchivo: true
            }
        });
    };
    const handleReset = () => {
        reset({});
        window.location.href = "/";
    };
    if (adjuntar) return (
        <VStack>

            <VStack>
                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleReset()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Finalizar
                        </Button>
                    </VStack>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleRedirect()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%", backgroundColor: "white",
                                borderRadius: "3px 8px 3px 8px",
                                border: "solid 2px", borderColor: "#3c3c3b",
                                color: "#3c3c3b",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Adjuntar archivos
                        </Button>
                    </VStack>
                </VStack>
            </VStack>

        </VStack>
    );

    if (loadingMutation) return <SpinnerCajas />;

    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );



    return (
        <VStack>
            <Heading level={3} mb={'8px'} fontWeight={400} tabIndex={0}>Datos del Cliente</Heading>


            {errorServicio ?
                <VStack mt={"20px"}>
                    <Heading level={3} mb={'8px'} fontWeight={400} tabIndex={0}>
                        Datos Personales
                    </Heading>
                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                        {mensajeError}
                    </Span>
                    <Button
                        onClick={() => handleReset()}
                        variant="secondary"
                        py={"10px !important"}
                    >
                        Volver
                    </Button>
                </VStack> :
                <></>}
            <Box>
                <VStack>

                    <form onSubmit={handleSubmit(onSubmit)}>

                        <VStack>
                            <input type={"text"} tabIndex={0}
                                {...register("cuit", {
                                    required: REQUIRED_FIELD, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                    maxLength: 11
                                })}
                                name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} disabled />

                        </VStack>
                        <VStack mt={"20px"} mb={"20px"}>
                            <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} disabled />
                        </VStack>


                        {esCliente ?
                            <VStack mb={"20px"}>
                                <input tabIndex={0} {...register("razonSocial", { maxLength: 120 })} name="razonSocial" maxLength={120} type={"text"} placeholder="Razon social" disabled />
                            </VStack>
                            :
                            <VStack mb={"20px"}>
                                <input tabIndex={0} {...register("razonSocial", { required: REQUIRED_FIELD, maxLength: 120 })} name="razonSocial" maxLength={120} type={"text"} placeholder="Razon social" />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                            </VStack>
                        }


                        <Controller
                            control={control}
                            name="rubro"
                            rules={{ required: true }}
                            render={({ field }) => {
                                return <RubrosOption {...field} onChangeValue={(e) => { field.onChange(e) }} />;
                            }}
                        />


                        {!esCliente && <>
                            <VStack mt={"20px"} mb={"20px"}>
                                <select tabIndex={0} {...register("datosTributarios", { required: REQUIRED_FIELD })} style={{ width: "100%" }} name="datosTributarios">
                                    <option value="">Seleccione datos tributarios</option>
                                    <option value="1">Sociedad Anonima (SA)</option>
                                    <option value="2">Sociedad de Responsabilidad Limitada (SRL)</option>
                                    <option value="3">Sociedad por Acciones Simplificada</option>
                                    <option value="4">Asociación Civil</option>
                                    <option value="5">Cooperativa</option>
                                    <option value="6">Otra</option>

                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.datosTributarios ? "* " + errors.datosTributarios.message : ""}</Span>
                            </VStack>

                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                Datos del apoderado
                            </Span>
                            <Box mt={"8px"} justifyContent={'space-between'} display={'flex'} flexDirection={'row'}>

                                <VStack mr={"0.5rem"}>
                                    <input {...register(`apoderadoNombre`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Nombre del apoderado' maxLength={25} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderadoNombre ? "* " + errors.apoderadoNombre.message : ""}</Span>
                                </VStack>
                                <VStack>
                                    <input {...register(`apoderadoApellido`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Apellido del apoderado' maxLength={25} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderadoApellido ? "* " + errors.apoderadoApellido.message : ""}</Span>
                                </VStack>

                            </Box>
                            <VStack mt={"20px"} mr={"0.5rem"}>
                                <input type={"text"}  {...register(`apoderadoDni`, { required: REQUIRED_FIELD, minLength: { value: 8, message: "cantidad minima de caracteres: 8" }, maxLength: 8, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} name="apoderadoDni" placeholder='DNI del apoderado' maxLength={8} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderadoDni && errors.apoderadoDni ? "* " + errors.apoderadoDni.message : ""}</Span>
                            </VStack>
                        </>
                        }


                        <VStack mt={"20px"}>
                            <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                Teléfono de contacto
                            </Span>
                            <VStack mt={"8px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                <VStack mr={"0.5rem"}>
                                    <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                </VStack>
                                <VStack>
                                    <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                </VStack>
                            </VStack>
                        </VStack>

                        {!esCliente && <>
                            <VStack mt={"20px"}>

                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio legal </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                            style={{ width: "100%" }}
                                            {...register("provincia", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                            <option value="">Provincia</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia ? "* " + errors.provincia.message : ""}</Span>
                                    </VStack>
                                    <VStack >
                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad comercio' >
                                            <option value="">Localidad </option>
                                            {localidades &&
                                                localidades.map((item: Localidad) =>
                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad ? "* " + errors.localidad.message : ""}</Span>
                                    </VStack>
                                </VStack>

                                <VStack mt={"20px"} mr={"0.5rem"}>
                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                                </VStack>
                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                    <VStack mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Nro' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostal", { required: REQUIRED_FIELD, maxLength: 8, })} name="codigoPostal" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostal?.message}</Span>
                                    </VStack>
                                </VStack>
                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("piso", { required: false, maxLength: 8, })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamento", { required: false, maxLength: 8, })} name="departamento" placeholder='Departamento' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamento?.message}</Span>
                                    </VStack>

                                </HStack>
                            </VStack>

                            <HStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio comercio </Span>
                                <input type='checkbox' tabIndex={0} style={{ transform: "scale(1.1)", marginLeft: "10px", marginTop: "-5px" }}  {...register("check", { required: false })} onChange={(e) => copiarDatos(e)} />
                                <Span ml={"8px"} color="secondary.1" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    copiar direccion
                                </Span>
                            </HStack>

                            {datosCopiados ?

                                <VStack mt={"20px"}>

                                    <VStack marginTop={"-16px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0}{...register("provinciaComercio", { required: false })} name="provinciaComercio" placeholder='Provincia' type={"text"} disabled />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio?.message}</Span>
                                        </VStack>
                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0}  {...register("localidadComercio", { required: false })} name="localidadComercio" placeholder='localidad comercio' type={"text"} disabled />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio?.message}</Span>
                                        </VStack>
                                    </VStack>
                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} disabled />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} disabled />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                        </VStack>
                                        <VStack>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: REQUIRED_FIELD, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                        </VStack>
                                    </VStack>
                                    <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                        </VStack>
                                        <VStack>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                        </VStack>

                                    </HStack>
                                </VStack>

                                :
                                <VStack mt={"20px"}>


                                    <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                        <VStack mr={"0.5rem"}>
                                            <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                                style={{ width: "100%" }}
                                                {...register("provinciaComercio", { required: REQUIRED_FIELD })}
                                                onChange={(e: any) => BuscLoc(e.target.value)} name="provinciaComercio" placeholder='Provincia' >
                                                <option value="">Provincia</option>
                                                <option value="2-Buenos Aires">Buenos Aires</option>
                                                <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                            </select>
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio ? "* " + errors.provinciaComercio.message : ""}</Span>
                                        </VStack>
                                        <VStack >
                                            <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidadComercio", { required: REQUIRED_FIELD })} name="localidadComercio" placeholder='Localidad comercio' >
                                                <option value="">Localidad </option>
                                                {localidades &&
                                                    localidades.map((item: Localidad) =>
                                                        <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                    )}
                                            </select>
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio ? "* " + errors.localidadComercio.message : ""}</Span>
                                        </VStack>
                                    </VStack>

                                    <VStack mt={"20px"} mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                        </VStack>
                                        <VStack>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: false, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                        </VStack>
                                    </VStack>
                                    <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                        <VStack mr={"0.5rem"}>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                        </VStack>
                                        <VStack>
                                            <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                        </VStack>

                                    </HStack>




                                </VStack>
                            }

                        </>
                        }

                        {esCliente &&

                            <VStack mt={"20px"}>

                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio comercio </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                            style={{ width: "100%" }}
                                            {...register("provinciaComercio", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provinciaComercio" placeholder='Provincia' >
                                            <option value="">Provincia</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provinciaComercio ? "* " + errors.provinciaComercio.message : ""}</Span>
                                    </VStack>
                                    <VStack >
                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidadComercio", { required: REQUIRED_FIELD })} name="localidadComercio" placeholder='Localidad comercio' >
                                            <option value="">Localidad </option>
                                            {localidades &&
                                                localidades.map((item: Localidad) =>
                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidadComercio ? "* " + errors.localidadComercio.message : ""}</Span>
                                    </VStack>
                                </VStack>

                                <VStack mt={"20px"} mr={"0.5rem"}>
                                    <input tabIndex={0} style={{ width: "100%" }} {...register("calleComercio", { required: REQUIRED_FIELD, maxLength: 50 })} name="calleComercio" placeholder='Calle' maxLength={50} type={"text"} />
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calleComercio ? "* " + errors.calleComercio.message : ""}</Span>
                                </VStack>
                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>

                                    <VStack mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("numeroCalleComercio", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalleComercio" placeholder='Nro' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalleComercio ? "* " + errors.numeroCalleComercio.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("codigoPostalComercio", { required: false, maxLength: 8, })} name="codigoPostalComercio" placeholder='Codigo postal' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.codigoPostalComercio?.message}</Span>
                                    </VStack>
                                </VStack>
                                <HStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("pisoComercio", { required: false, maxLength: 8, })} name="pisoComercio" placeholder='Piso' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.pisoComercio?.message}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("departamentoComercio", { required: false, maxLength: 8, })} name="departamentoComercio" placeholder='Departamento' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.departamentoComercio?.message}</Span>
                                    </VStack>

                                </HStack>




                            </VStack>
                        }




                        <Controller
                            control={control}
                            name="sucursal"
                            rules={{ required: true }}
                            render={({ field }) => {
                                return <ComboSucursales {...field} onChangeValue={(e) => { field.onChange(e) }} titulo={"Sucursal cercana"} sucursalCliente={sucursalCliente} />
                            }}
                        />

                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.sucursal?.message}</Span>
                        <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                    </form>
                </VStack>
            </Box>


        </VStack>
    )

}



